import { InjectionToken } from '@angular/core';
import { AppConfig } from '../config';

export const COMPANY_ID = new InjectionToken<string>('COMPANY_ID_TOKEN');
export const APP_CONFIG = new InjectionToken<AppConfig>('APP_CONFIG_TOKEN');
export const BASE_API_ROUTE = new InjectionToken<string>('BASE_API_ROUTE_TOKEN');
